(() => {
  document.querySelectorAll('[data-vpw-diag]').forEach((box) => {
    const st = { p: 'klein', h: '100' };
    const ziel = () => (st.p === 'hoehe' ? 'hoehe' : st.h === '200' ? '200' : st.h === '400' ? '400' : st.p);
    const zeigen = () => {
      const z = ziel();
      box.querySelectorAll('[data-vpw-erg]').forEach((a) => { a.hidden = a.dataset.vpwErg !== z; });
      box.querySelectorAll('[data-vpw-frage="h"] button').forEach((b) => { b.disabled = st.p === 'hoehe'; });
    };
    box.addEventListener('click', (e) => {
      const b = e.target instanceof Element && e.target.closest('[data-vpw-frage] button');
      if (!b || b.disabled) return;
      const gruppe = b.closest('[data-vpw-frage]');
      gruppe.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      st[gruppe.dataset.vpwFrage] = b.dataset.v;
      zeigen();
    });
    zeigen();
  });
})();
